document.addEventListener('alpine:init', () => {
    const cartJSON = JSON.parse(document.getElementById("cartJSON").textContent.trim()); // State of the Cart on page load
    const urlParams = new URLSearchParams(document.location.search);
    const config = {
        "rebuy_widget_id": (15716, 16016)
    }

    Alpine.store('pk', {
        cart: cartJSON,
        init() {
            let formData = {"attributes": {}, "updates": {}, "sections": "cart-json"};
            let giftsInCart = cartJSON.items.filter(element => element.is_gift === true);

            // Remove any gifts if the Cart total is $0
            if (giftsInCart.length > 0 && cartJSON.total_price === 0) {
                giftsInCart.forEach(element => {
                    formData.updates[element.key] = 0;
                });
            }

            fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(cart => {
                this.updateCart(cart);
            })

            document.addEventListener('rebuy.ready', (event) => {
                const rebuySpinner = document.querySelector(".rebuy-loading");

                if (this.open) {
                    this.showRebuy = true;

                    if (rebuySpinner) {
                        rebuySpinner.classList.add("hidden");
                    }
                }
            });

            document.addEventListener('rebuy.add', (event) => {
                this.refreshCart();
            });
        },
        loading: false,
        giftLoading: false,
        open: false,
        showRebuy: false,
        toggle() {
            this.open = ! this.open;

            document.body.classList.toggle("overflow-hidden");

            if ( ! this.open) {
                this.showRebuy = false;

                const rebuySpinner = document.querySelector(`div[data-rebuy-id="${config.rebuy_widget_id}"] + div`);

                if (rebuySpinner !== null) {
                    rebuySpinner.classList.remove("hidden");
                }
            } else if (this.open && this.cart.item_count > 0 && window.Rebuy) {
                const rebuyWidget = document.querySelector(`div[data-rebuy-id="${config.rebuy_widget_id}"]`);

                if (rebuyWidget === null) {
                    return;
                }

                window.Rebuy.widgets.length = 0;

                rebuyWidget?.replaceChildren();
                delete rebuyWidget?.dataset["initialized"];

                if (typeof Rebuy.init === "function") {
                    Rebuy.init();
                }
            }
        },
        addBundleToCart(event, $dispatch) {
            const form = event.target;
            const formData = new FormData(form);
            const button = form.querySelector("button[type='submit']");
            const flavors = formData.getAll("flavor");
            const quantity = formData.get("quantity");
            const items = [];

            flavors.forEach(flavor => {
                items.push({
                    "id": flavor,
                    "quantity": quantity
                });
            });

            button.classList.add("opacity-25", "pointer-events-none");

            this.addItems(items).then(cart => {
                this.updateCart(cart);
            }).finally(() => {
                button.classList.remove("opacity-25", "pointer-events-none");

                $dispatch('toggle');
            });
        },
        addBonesCoffee(event, $dispatch) {
            const form = event.target;
            const button = form.querySelector("button[type='submit']");
            const selects = form.querySelectorAll('select');
            const items = [];

            button.classList.add("opacity-25", "pointer-events-none");

            selects.forEach(element => {
                const option = form.querySelector(`input[name='${element.selectedOptions[0].dataset.option}']:checked`).value;
                const variantId = element.selectedOptions[0].dataset[option];

                items.push({
                    id: variantId,
                    quantity: 1
                })
            })

            this.addItems(items).then(cart => {
                this.updateCart(cart);
            }).finally(() => {
                button.classList.remove("opacity-25", "pointer-events-none");

                $dispatch('toggle');
            });
        },
        addBonesUpsell(event, $dispatch) {
            const form = event.target;
            const formData = new FormData(form);
            const button = form.querySelector("button[type='submit']");
            const items = [];

            button.classList.add("opacity-25", "pointer-events-none");

            items.push({
                "id": formData.get('id'),
                "quantity": formData.get('quantity')
            });

            this.addItems(items).then(cart => {
                this.updateCart(cart);
            }).finally(() => {
                button.classList.remove("opacity-25", "pointer-events-none");

                $dispatch('toggle');
            });
        },
        selectBundleSize(event) {
            const form = event.target.form;
            const quantityInput = form.querySelector("input[name='quantity']");
            const button = form.querySelector("button");
            const bundleSize = event.target.value;
            const flavors = form.querySelectorAll("input[name='flavor']");
            const flavorInputType = (bundleSize == 1) ? "radio" : "checkbox";

            if (document.querySelector("a[data-image-id='39925490221251']")) {
                document.querySelector("a[data-image-id='39925490221251']").click();
            }

            quantityInput.value = (bundleSize == 1) ? 2 : 1;

            flavors.forEach((flavor, index) => {
                flavor.checked = false;

                flavor.setAttribute("type", flavorInputType);

                if (index < bundleSize) {
                    flavor.checked = true;
                }
            });

            button.disabled = false;
            button.querySelector(".icon").classList.remove("hidden");
            button.querySelector(".icon + span").textContent = "Add to Cart";
        },
        selectBundleFlavor(event) {
            const form = event.target.form;
            const button = form.querySelector("button");
            const flavors = form.querySelectorAll("input[name='flavor']");
            const selectedSize = form.querySelector("input[name='size']:checked");
            const selectedFlavors = form.querySelectorAll("input[name='flavor']:checked");

            if (event.target.checked) {
                const checkbox = event.target;

                if (checkbox.value == 42145266827459) {
                    document.querySelector("a[data-image-id='39914329440451']").click();
                } else if (checkbox.value == 42145264009411) {
                    document.querySelector("a[data-image-id='39914329374915']").click();
                } else if (checkbox.value == 42145266761923) {
                    document.querySelector("a[data-image-id='39914329473219']").click();
                } else if (checkbox.value == 42145264009411) {
                    document.querySelector("a[data-image-id='39895048683715']").click();
                } else if (checkbox.value == 42251069096131) {
                    document.querySelector("a[data-image-id='39914329505987']").click();
                } else if (checkbox.value == 42145266860227) {
                    document.querySelector("a[data-image-id='39914329538755']").click();
                }
            }

            if (selectedSize.value == 2) {
                switch (selectedFlavors.length) {
                    case 0:
                        button.disabled = true;
                        button.querySelector(".icon").classList.add("hidden");
                        button.querySelector(".icon + span").textContent = "Select 1st Flavor";
                        break;
                    case 1:
                        button.disabled = true;
                        button.querySelector(".icon").classList.add("hidden");
                        button.querySelector(".icon + span").textContent = "Select 2nd Flavor";
                        break;
                    case 2:
                        button.disabled = false;
                        button.querySelector(".icon").classList.remove("hidden");
                        button.querySelector(".icon + span").textContent = "Add to Cart";
                        break;
                    default:
                        // Reset flavor selection when checked flavors is more than two
                        flavors.forEach(flavor => {
                            flavor.checked = false;
                        });

                        event.target.checked = true;

                        button.disabled = true;
                        button.querySelector(".icon").classList.add("hidden");
                        button.querySelector(".icon + span").textContent = "Select 2nd Flavor";
                }
            }
        },
        get itemCountWithoutGifts() {
            return this.cart.items.filter(item => item.final_price > 0).length;
        },
        async addToBundle(event, $dispatch) {
            //const button = event.submitter;
            const form = event.target;
            const formData = new FormData(form);
            const button = form.querySelector("button");
            const item = {};

            if (button) {
                button.classList.add("opacity-25", "pointer-events-none");
            }

            for (const [key, value] of formData) {
                item[key] = value;
            }

            this.addItems([item]).then(cart => {
                this.updateCart(cart);
            }).finally(() => {
                if (button) {
                    button.classList.remove("opacity-25", "pointer-events-none");
                }

                $dispatch('toggle');
            });
        },
        get bundleProgressTitle() {
            let title = "";

            switch(this.itemCountWithoutGifts) {
                case 0:
                    title = "Add 1 item to get 15% off!";
                    break;
                case 1:
                    title = "Add 1 more item to get 20% off!";
                    break;
                case 2:
                    title = "Add 1 more item to get 30% off!";
                    break;
                case 3:
                    title = "Add 2 more items to get 40% off!";
                    break;
                case 4:
                    title = "Add 1 more item to get 40% off!";
                    break;
                case 5:
                    title = "Add 1 more item to get 50% off!";
                    break;
                default:
                    title = "Congrats! You've unlocked 50% off!";
            }

            return title;
        },
        get uniqueCartItems() {
            // This method is useful for when bundle items are in the Cart
            // since bundle items will be duplicated
            // TODO: Write documentation for this method and how it works with bundles

            return [...new Map(this.cart.items.map(item => [item.key, item])).values()];
        },
        async refreshCart() {
            this.loading = true;

            const cart = await fetch("/?sections=cart-json").then(response => response.json());

            this.updateCart(cart);

            this.loading = false;
        },
        setBundleProperties(form) {
            const formData = new FormData(form);
            const variants = formData.getAll('id');

            const input = form.querySelector("input[type='hidden'][name='properties[_bundle_ids]']");

            if (input) {
                input.value = variants.join(',');
            }
        },
        addMultiProductsToCart(form, $dispatch) {
            const formData = new FormData(form);
            const variants = formData.getAll('id');
            const quantity = formData.get('quantity');
            const properties = {};
            const items = [];

            this.loading = true;

            // Check for item "properties"
            for (const [key, value] of formData) {
                if (key.includes('properties')) {
                    // Get the name of the property between the square brackets
                    // Example 'properties[bundle]' will return 'bundle'
                    const propertyName = key.replace(/properties\[(.*?)\]/, '$1');

                    properties[propertyName] = value;
                }
            }

            variants.forEach(element => {
                items.push({
                    'id': element,
                    'quantity': quantity,
                    'properties': properties
                });
            });

            this.addItems(items).then(cart => {
                this.updateCart(cart);
            }).finally(() => {
                this.loading = false;

                $dispatch('toggle');
            });
        },
        addProductToCart(form, $dispatch, options = {}) {
            const formData = new FormData(form);

            this.loading = true;

            const item = {};
            const properties = {};

            for (const [key, value] of formData) {
                /**
                 * To add a variant to the cart with line item properties use the "properties" property.
                 * Its value must be an object of key-value pairs.
                 *
                 * FormData sends the property name like this: "properties[shipping_interval_frequency]",
                 * so first we need to extract the string inside the square brackets before adding it
                 * to the "properties" object.
                 *
                 * Docs: https://shopify.dev/api/ajax/reference/cart#post-locale-cart-add-js
                 */
                if (key.includes("properties")) {
                    let propertyName = key.replace(/properties\[(.*?)\]/, '$1');

                    properties[propertyName] = value;
                } else {
                    // The rest of the product FormData ("quantity" and "id") can be sent as-is.
                    item[key] = value;
                }
            }

            // Append the "properties" to the "item" object that will be added to the Cart.
            item.properties = properties;

            this.addItems([item]).then(cart => {
                let productId = cart.items[0].product_id;

                this.loading = false;

                this.updateCart(cart);
            }).finally(() => {
                if ( ! Object.hasOwn(options, 'openDrawer') || Object.hasOwn(options, 'openDrawer') && options.openDrawer === true) {
                    $dispatch('toggle');
                }

                // Close the popup if the product is being added from the Quick View
                if (window.$.fancybox !== undefined) {
                    window.$.fancybox.close();
                }
            });
        },
        async changeItem(key, properties) {
            /**
             * The POST data requires either an 'id' or 'line' property
             * to identify the line item to be changed.
             */
            let formData = {
                "id": `${key}`,
                "sections": "cart-json"
            }

            // TODO: Get current line item properties

            if ('quantity' in properties) {
                formData['quantity'] = properties['quantity'];
            }

            if ('properties' in properties) {
                formData['properties'] = properties['properties'];
            }

            let response = await fetch(window.Shopify.routes.root + "cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            return await response.json();
        },
        async updateItems(items) {
            let formData = {
                "updates": items,
                "sections": "cart-json"
            };

            let response = await fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            return await response.json();
        },
        async addItems(items) {
            /**
             * Use the POST /cart/add.js endpoint to add one or multiple variants to the cart.
             *
             * Docs: https://shopify.dev/api/ajax/reference/cart#post-locale-cart-add-js
             */
            let formData = {
                "items": items,
                "sections": "cart-json"
            };

            /*
            try {
                items.forEach(element => {
                    TriplePixel('AddToCart', { item: element.id, q: parseInt(element.quantity, 10) });
                })
            } catch { }
            */

            let response = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            // Return the JSON of the line items associated with the added variants
            return await response.json();
        },
        removeItem(lineItem) {
            // The item(s) to be removed (in some cases other items will be removed as well)
            // TODO: Explain in details why
            const items = {};

            this.loading = true;

            if (lineItem.is_bundle) {
                lineItem.bundle_variants.forEach(element => {
                    items[element] = 0;
                });
            } else {
                items[lineItem.key] = 0;
            }

            /*
            if (lineItem.vendor === "Wonder Monday") {
                const minimumQuantity = 2;

                const quantityToUpdate = lineItem.quantity * -1;

                // Get all of the Wonder Monday items
                const filteredItems = this.cart.items.filter(element => element.vendor === "Wonder Monday");

                // Sum the quantity of Wonder Monday items in the Cart
                const totalQuantity = filteredItems.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.quantity;
                }, 0);

                // Remove all Wonder Monday items if the sum (after the current
                // item is removed) is inferior to the minimum quantity required
                if (totalQuantity + quantityToUpdate < minimumQuantity) {
                    // Set the quantity to 0 of each Wonder Monday item in the Cart
                    filteredItems.forEach(element => {
                        items[element.key] = 0;
                    });
                }
            }
            */

            // Bones Coffee check
            const bonesCoffeeIds = [7506511560899, 7506511429827, 7506511528131, 7506511462595, 7506511495363];

            if (bonesCoffeeIds.includes(lineItem.product_id)) {
                const minimumQuantity = 2;

                const quantityToUpdate = lineItem.quantity * -1;

                // Get all of the filtered items
                const filteredItems = this.cart.items.filter(element => bonesCoffeeIds.includes(element.product_id));

                // Sum the quantity of filtered items in the Cart
                const totalQuantity = filteredItems.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.quantity;
                }, 0);

                // Remove all filtered items if the sum (after the current
                // item is removed) is inferior to the minimum quantity required
                if (totalQuantity + quantityToUpdate < minimumQuantity) {
                    // Set the quantity to 0 of each filtered item in the Cart
                    filteredItems.forEach(element => {
                        items[element.key] = 0;
                    });
                }
            }

            this.updateItems(items)
                .then(response => {
                    this.updateCart(response);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        changeQuantity(event) {
            const items = {};
            const lineItem = event.item;
            const newQuantity = event.action === 'increase' ? Math.min(12, (lineItem.quantity + 1)) : (lineItem.quantity - 1);

            this.loading = true;

            if (lineItem.is_bundle) {
                lineItem.bundle_variants.forEach(element => {
                    items[element] = newQuantity;
                });
            } else {
                items[lineItem.key] = newQuantity;
            }

            /*
            if (lineItem.vendor === "Wonder Monday") {
                const minimumQuantity = 2;

                const quantityToUpdate = event.action === 'increase' ? +1 : -1;

                // Get all of the Wonder Monday items
                const filteredItems = this.cart.items.filter(item => item.vendor === "Wonder Monday");

                // Sum the quantity of Wonder Monday items in the Cart
                const totalQuantity = filteredItems.reduce((accumulator, item) => {
                    return accumulator + item.quantity;
                }, 0);

                // Remove all Wonder Monday items if the sum (after the current
                // item is removed) is inferior to the minimum quantity required
                if (totalQuantity + quantityToUpdate < minimumQuantity) {
                    // Set the quantity to 0 of each Wonder Monday item in the Cart
                    filteredItems.forEach(item => {
                        items[item.key] = 0;
                    });
                }
            }
            */

            // Bones Coffee check
            const bonesCoffeeIds = [7506511560899, 7506511429827, 7506511528131, 7506511462595, 7506511495363];

            if (bonesCoffeeIds.includes(lineItem.product_id)) {
                const minimumQuantity = 2;

                const quantityToUpdate = event.action === 'increase' ? +1 : -1;

                // Get all of the filtered items
                const filteredItems = this.cart.items.filter(element => bonesCoffeeIds.includes(element.product_id));

                // Sum the quantity of the filtered items in the Cart
                const totalQuantity = filteredItems.reduce((accumulator, item) => {
                    return accumulator + item.quantity;
                }, 0);

                // Remove all filtered items if the sum (after the current
                // item is removed) is inferior to the minimum quantity required
                if (totalQuantity + quantityToUpdate < minimumQuantity) {
                    // Set the quantity to 0 of each filtered item in the Cart
                    filteredItems.forEach(item => {
                        items[item.key] = 0;
                    });
                }
            }

            this.updateItems(items).then(response => {
                this.updateCart(response);
            }).finally(() => {
                this.loading = false;
            });
        },
        async checkVariantsQuantity() {
            let cart = await fetch('/cart.js').then(cart => cart.json());
            cart.items.forEach(item => {
                if(item.quantity > 12) {
                    let items = {};
                    let key = `${item.id}:${item.token}`;

                    items[key] = 12;

                    this.updateItems(items);

                    this.loading = true;
                    this.updateItems(items).then(response => {
                        this.updateCart(response);
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            })

        },
        updateSubscriptionFrequency(value, item) {
            if (value === "onetime") {
                this.loading = true;

                this.updateItems({
                    [item.key]: 0,
                    [item.original_variant_id]: item.quantity
                }).then(data => {
                    this.updateCart(data);
                }).finally(() => {
                    this.loading = false;
                });
            } else {
                /**
                 * Whenever a POST request includes properties, it overwrites the entire properties object.
                 * Any key-value pairs that were already in the properties object are erased.
                 *
                 * For this reason, the new subscription frequency has to be assigned to the current line
                 * item properties.
                 */
                const properties = Object.assign(item.properties, {"shipping_interval_frequency": value});

                this.changeItem(item.key, {"quantity": item.quantity, "properties": properties}).then((cart) => {
                    this.updateCart(cart);
                });
            }
        },
        async upgradeToSubscription(item) {
            this.loading = true;

            this.updateItems({
                [item.key]: 0
            }).then(data => {
                return this.addItems([
                    {
                        "id": item.variant_id,
                        "quantity": item.quantity,
                        "selling_plan": item.selling_plan_id
                    }
                ]);
            }).then(data => {
                this.loading = false;

                this.updateCart(data);
            });
        },
        updateCart(cart) {
            /**
             * Section rendering allows to request the HTML markup of sections
             * based on an initial call to the Cart API.
             *
             * Each of the AJAX requests we're making to add/update/change items
             * will return the HTML of the "cart-json" section.
             *
             * That section contains a string formatted as a JSON object with the
             * state of the Cart after making those requests.
             *
             * The reason for doing it this way is because Liquid files allow to
             * access product metafields that aren't available in the JSON object
             * returned from Cart requests.
             *
             * For example: to give users the ability to upgrade an item to a
             * subscription we need to know the ReCharge variant id, which is stored
             * as a metafield.
             *
             * Docs: https://shopify.dev/api/ajax/reference/cart#bundled-section-rendering
             */
            const formData = {};
            const cartJSONContent = cart["cart-json"] || cart.sections["cart-json"];
            const startIndex = cartJSONContent.indexOf("{");
            const endIndex = cartJSONContent.lastIndexOf("}") + 1;
            const newCart = JSON.parse(cartJSONContent.substring(startIndex, endIndex));
            const giftsInCart = newCart.items.filter(element => element.is_gift === true);
            const cartHasBonusGift = giftsInCart.some(element => element.is_bonus_gift === true);

            /**
             * Cart is no longer eligible for a gift.
             * Check if there is any in the Cart and remove it.
             *
             * Also remove the bonus gift if it's in the Cart
             * but it's not enabled in the theme settings.
             */
            if (
                this.cartHasGift(newCart) && this.isGiftRedeemable(newCart) === false ||
                (cartHasBonusGift && newCart.gift?.bonus?.enabled === false)
            ) {
                // Reset all gifts
                giftsInCart.forEach(item => {
                    formData[item.id] = 0;
                });

                this.updateItems(formData).then(response => {
                    this.updateCart(response);
                });
            } else if (
                this.isGiftRedeemable(newCart) &&
                newCart.gift?.add_automatically &&
                giftsInCart.find(element => element.product_id === newCart.gift?.id) === undefined
            ) {
                // By default add the first variant of the gift product
                const giftVariantId = newCart.gift?.variants[0].id;;

                /**
                 * First, reset all gifts. This step is important because sometimes
                 * we may need to swap gifts based on the Cart contents
                 */
                giftsInCart.forEach(item => {
                    formData[item.id] = 0;
                });

                formData[giftVariantId] = 1;

                this.updateItems(formData).then(response => {
                    this.updateCart(response);
                });
            } else if (
                newCart.total_price > 0 &&
                newCart.gift?.bonus?.enabled &&
                cartHasBonusGift === false
            ) {
                // Add bonus gift to the Cart
                formData[newCart.gift?.bonus?.variant_id] = 1;

                this.updateItems(formData).then(response => {
                    this.updateCart(response);
                });
            } else if (
                this.cartHasCollagen(newCart) &&
                newCart.gift?.add_automatically === false &&
                newCart.items.some(element => element.product_id === newCart.gift?.id) === false
            ) {
                const bundleIds = newCart.gift?.variants.map(element => element.id).join(',');
                let items = [];

                // Reset gifts
                giftsInCart.forEach((item) => {
                    formData[item.id] = 0;
                });

                newCart.gift?.variants.forEach(element => {
                    items.push({
                        quantity: 1,
                        id: element.id,
                        properties: {
                            '_bundle': newCart.gift.handle,
                            '_bundle_ids': bundleIds,
                            'Bundle': newCart.gift.title
                        }
                    })
                });

                this.updateItems(formData).then(() => {
                    return this.addItems(items);
                }).then(response => {
                    this.updateCart(response);
                });
            } /*else if (
                this.cartHasCollagen(newCart) === false &&
                newCart.items.some(element => element.is_bundle && element.is_bonus_gift === false && element.final_price === 0)
            ) {
                const collagenBundleGifts = newCart.items.filter(element => element.is_bundle && element.is_bonus_gift === false && element.final_price === 0);

                // Reset gifts
                collagenBundleGifts.forEach((item) => {
                    formData[item.id] = 0;
                });

                this.updateItems(formData).then(response => {
                    this.updateCart(response);
                });
            } else if (
                newCart.total_price === 0 &&
                newCart.items.length > 0
            ) {
                // Remove all items from Cart if all
                // of them are priced at $0
                newCart.items.forEach(item => {
                    formData[item.id] = 0;
                });

                this.updateItems(formData).then(response => {
                    this.updateCart(response);
                });
            }*/ else {
                this.loading = false;
                this.cart = newCart;
            }

            this.checkVariantsQuantity();
        },
        async rejectGift() {
            let formData = {
                attributes: {
                    "gift_rejected": "true"
                },
                "sections": "cart-json"
            }

            let response = await fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            return await response.json();
        },
        async selectGift(variantId) {
            let formData = {};

            this.giftLoading = true;

            this.cart.gift.variants.forEach((item) => {
                formData[item.id] = (item.id == variantId) ? 1 : 0;
            });

            this.updateItems(formData).then(cart => {
                this.giftLoading = false;

                this.updateCart(cart);
            });
        },
        cartHasSubscriptions() {
            return this.cart.items.some(element => element.is_subscription === true);
        },
        get giftsInCart() {
            return this.cart.items.filter(element => element.is_gift && element.is_bonus_gift === false);
        },
        cartHasGift(cart = this.cart) {
            return cart.items.some(element => element.is_gift === true && element.is_bonus_gift === false);
        },
        cartHasMembership(cart = this.cart) {
            return cart.items.some(element => element.sku === 'PK-MEMBER-ANNUAL');
        },
        cartHasCollagen(cart = this.cart) {
            return cart.items.some(element => element.is_collagen === true);
        },
        shippingRemainingAmount() {
            return this.formatMoney((this.cart.shipping_threshold - this.cart.total_price), 'cents');
        },
        giftRemainingAmount() {
            return this.formatMoney((this.cart.gift_threshold - this.cart.total_price), 'cents');
        },
        isGiftRedeemable(cart = this.cart) {
            return (cart.total_price - cart.gift_threshold > 0);
        },
        isGift(variantId) {
            return this.cart.gift.variants.find(element => element.id == variantId);
        },
        isSelectedGift(variantId) {
            const gift = this.isGift(variantId);

            if (gift === undefined) {
                return;
            }

            return gift.selected;
        },
        hasFreeShipping() {
            return this.cartHasSubscriptions() || ((this.cart.shipping_threshold - this.cart.total_price) / 100) < 0;
        },
        get shippingPercentage() {
            if (this.hasFreeShipping()) {
                return "100%";
            }

            if (this.cart.total_price === 0) {
                return "0%";
            }

            return `${this.cart.total_price / this.cart.shipping_threshold * 100}%`;
        },
        get giftPercentage() {
            if (this.cartHasGift() || this.isGiftRedeemable()) {
                return "100%";
            }

            if ( ! this.hasFreeShipping()) {
                return "0%";
            }

            return `${this.cart.total_price / this.cart.gift_threshold * 100}%`;
        },
        showLowInventory(quantity) {
            let label = this.cart.strings.low_inventory;

            return label.replace("[X]", quantity);
        },
        formatMoney(amount, unit = "dollars") {
            if (unit === "cents") {
                amount /= 100;
            }

            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                currencyDisplay: "symbol"
            }).format(amount);
        },
        get isProductPage() {
            // TODO: Use window variables (eg: window.ShopifyAnalytics) to be more accurate
            if (document.body.classList.contains("template-product")) {
                return true;
            }

            return false;
        },
        triggerBackInStockPopup(event) {
            console.log(event)
        },
        subscribeBackInStock(form) {
            const formData = new FormData(form);
            const customerEmail = formData.get('email');
            const variantId = formData.get('id');
            const feedbackMessage = document.createElement('div');
            let responseText;

            feedbackMessage.classList.add('mt-3', 'text-center', 'text-black', 'text-sm', 'py-3', 'font-normal', 'px-2', 'rounded-md');

            form.classList.add('opacity-25', 'pointer-events-none');

            const options = {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    revision: '2025-01-15',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            channels: ['EMAIL'],
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: customerEmail
                                    }
                                }
                            }
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: 'catalog-variant',
                                    id: `$shopify:::$default:::${variantId}`
                                }
                            }
                        }
                    }
                })
            };

            fetch(form.action, options)
                .then(response => {
                    console.log(response);

                    if (response.status === 202) {
                        responseText = "🤩 Success! You're now on the list. We'll notify you when the product is back in stock.";

                        feedbackMessage.classList.add('bg-green-100');
                        feedbackMessage.innerText = responseText;
                    } else {
                        responseText = "Oops! Something went wrong. Please try again later or contact support.";

                        throw new Error(responseText);
                    }
                })
                .catch(error => {
                    console.error(error);

                    feedbackMessage.classList.add('bg-red-100');

                    feedbackMessage.innerText = error.message;
                })
                .finally(() => {
                    form.append(feedbackMessage);

                    form.classList.remove('opacity-25', 'pointer-events-none');

                    setTimeout(() => {
                        feedbackMessage.remove();
                    }, 3000);
                });
        },
    })
})